import React from 'react';

type MovingBarProps = {
  color?: string;
  width?: number;
  height?: number;
  durationMs?: number;
};

export const MovingBar: React.FC<MovingBarProps> = ({
  color = 'white',
  width = 40,
  height = 4,
  durationMs = 1000,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="24"
      viewBox="0 0 120 24"
      role="img"
      aria-label="Loading"
    >
      <g fill="currentColor">
        <circle cx="20" cy="12" r="4">
          <animate
            attributeName="opacity"
            values="0.2;1;0.2"
            dur="1.2s"
            repeatCount="indefinite"
            begin="0s"
          />
        </circle>

        <circle cx="60" cy="12" r="4">
          <animate
            attributeName="opacity"
            values="0.2;1;0.2"
            dur="1.2s"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </circle>

        <circle cx="100" cy="12" r="4">
          <animate
            attributeName="opacity"
            values="0.2;1;0.2"
            dur="1.2s"
            repeatCount="indefinite"
            begin="0.4s"
          />
        </circle>
      </g>
    </svg>
  );
};
